import { render, staticRenderFns } from "./ModalContentTerms.vue?vue&type=template&id=712da243"
import script from "./ModalContentTerms.vue?vue&type=script&lang=js"
export * from "./ModalContentTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports